<template>
  <div id="businessAddress">
    <a-form
      ref="step5Ref"
      class="ant-round-form material-articles-association-form"
      layout="vertical"
      :model="modelForm"
      :rules="rules"
      @finish="submit"
    >

      <!-- company business address type companyAddressType selection -->
      <a-form-item name="companyAddressType" :label="$t('pages_merchant2_024')" :rules="{ required: true }">
        <a-select
          v-model:value="modelForm.companyAddressType"
          show-search
          size="large"
          option-filter-prop="label"
          :placeholder="$t('pages_merchant2_024')"
          :disabled="modelForm.companyAddressTypeDisabled"
        >
          <a-select-option
            v-for="item in companyAddressTypes"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          >{{ item.name }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.companyAddressTypeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.companyAddressTypeMessage }}</span>
        </div>
      </a-form-item>
      <!-- realCompanyAddress input-->
      <a-form-item name="realCompanyAddress" :label="$t('pages_merchant2_025')" :rules="{ required: true }">
        <a-input
          v-model:value="modelForm.realCompanyAddress"
          size="large"
          allow-clear
          :disabled="modelForm.realCompanyAddressDisabled"
          :placeholder="$t('pages_merchant2_025')"
        />
        <div v-if="!modelForm.realCompanyAddressDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.realCompanyAddressMessage }}</span>
        </div>
      </a-form-item>
      <a-form-item name="bizAddrPath" :label="$t('pages_merchant2_026')" :rules="{ required: true }">
        <explain>{{ $t("pages_merchant2_026_0") }}</explain>
        <upload-auto
          ref="uploadBizAddrPathRef"
          v-model:file-content="modelForm.bizAddrPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.bizAddrPathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.bizAddrPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.bizAddrPathMessage }}</span>
        </div>
      </a-form-item>

      <a-form-item style="text-align: right; margin-top: 48px">
        <a-button
          type="primary"
          shape="round"
          ghost
          style="min-width: 138px; margin-right: 24px"
          @click="$emit('next', '2-1')"
        >{{ $t('pages_merchant_040') }}</a-button>
        <a-button
          html-type="submit"
          type="primary"
          shape="round"
          style="min-width: 138px"
        >{{ $t('pages_merchant_020') }}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { ref, reactive, toRefs, computed, nextTick } from 'vue'
import UploadAuto from '@/components/upload-auto'
import i18n from '@/locale'
export default {
  name: 'BusinessAddress',
  components: {
    'upload-auto': UploadAuto
  },
  props: {
    model: {
      type: Object,
      default: () => { return {} }
    },
    refused: {
      type: Boolean,
      default: () => { return false }
    }
  },
  setup (props, ctx) {
    const step5Ref = ref(null)
    const uploadBizAddrPathRef = ref(null)

    // 0自租办公室 1秘书处挂靠地址 2共享办公室 3-自有房产
    const companyAddressTypes = [
      { id: '0', name: i18n.global.t('pages_merchant2_024_0') },
      { id: '1', name: i18n.global.t('pages_merchant2_024_1') },
      { id: '2', name: i18n.global.t('pages_merchant2_024_2') },
      { id: '3', name: i18n.global.t('pages_merchant2_024_3') }
    ]

    const state = reactive({
    })

    state.modelForm = computed(() => {
      return props.model
    })

    const submit = () => {
      ctx.emit('next', '2-3')
    }

    nextTick(() => {
      const { bizAddrPath } = state.modelForm
      if (bizAddrPath.length > 0 && uploadBizAddrPathRef.value) {
        uploadBizAddrPathRef.value.fileListRefresh(bizAddrPath)
      }
    })

    return {
      step5Ref,
      uploadBizAddrPathRef,
      companyAddressTypes,
      submit,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#articlesAssociation {
  .material-business-license {
    .explain {
      color: #495060;
    }
  }
}

</style>

